import React from "react";
import { Radio } from "tea-component";
import './index.scss';
import { shallowEqual, useSelector } from "umi";
// 副标题
export  const MainChartsMessages = ({ ...props }: any) => {
  const { dblFormatMessage, searchFormRef, isEn } = props;
  const {game_cn_name: gameCnName, game_name: gameName} = useSelector((state: any) => state.datalab.currentGame, shallowEqual);
  const isTemplate =
    searchFormRef?.current?.latestCountRef?.current?.values?.category ===
    'game_template';
  const title = dblFormatMessage(
    isTemplate ? 'set_template_public_info' : 'set_template_game_info',
  );
  const addPermissionEndText = dblFormatMessage(
    'set_template_game_info_detail',
  );
  const addPermissionDatalan = dblFormatMessage(
    'set_template_game_info_permissions',
  );
  return (
    <div className="dbi-template-main-charts-messages">
      {title}
      {/* TODO: 中英文??? */}
      {isTemplate && <span>【{isEn ? `${gameName}` : gameCnName}】</span>}
      <span>{addPermissionDatalan}</span>
      {addPermissionEndText}
    </div>
  );
};
// 主单选组件
export const TemplateGroupRadio = (props: any) => {
  const { dblFormatMessage, ...restProps } = props;
  const { isPermissionAdmin } = useSelector((state: any) => ({
    isPermissionAdmin: state.privilegesConfig.isPermissionAdmin,
  }), shallowEqual);
  return (
    <>
      <Radio.Group {...restProps}>
        <Radio name="game_template">{dblFormatMessage('game_template')}</Radio>
        {isPermissionAdmin && <Radio name="public_template" style={{marginLeft: '12px'}}>{dblFormatMessage('public_template')}</Radio>}
      </Radio.Group>
      <MainChartsMessages {...props} />
    </>
  );
};